import "antd/dist/antd.css"

import { QueryClientProvider } from "@tanstack/react-query"
import { ConfigProvider } from "antd"
import ptBR from "antd/es/locale/pt_BR"
import { Provider } from "react-redux"
import { BrowserRouter as Router } from "react-router-dom"

import { queryClientConfig } from "./lib/react-query"
import { ErrorBoundary } from "./lib/sentry/error-boundary"
import { store } from "./redux/store"
import { Routes } from "./routes"

export default function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider locale={ptBR}>
        <Provider store={store}>
          <QueryClientProvider client={queryClientConfig}>
            <Router>
              <Routes />
            </Router>
          </QueryClientProvider>
        </Provider>
      </ConfigProvider>
    </ErrorBoundary>
  )
}
